import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';

export const APopover = ({
  content,
  children,
  placement = 'bottom',
  className,
  panelClassName,
  showIcon,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleOpen = () => {
    clearTimeout(timeoutRef.current);
    setIsOpen(true);
  };

  const handleClose = () => {
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 100); // Match this duration with your CSS transition time
  };

  return (
    <Popover
      className={className}
      open={isOpen}
      onClose={() => setIsOpen(false)}
    >
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        className="relative h-full"
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
      >
        <PopoverButton as="div" className="focus:outline-none">
          {showIcon ? (
            <div className="flex items-center gap-3 px-4 py-2">
              {children}
              <span
                className={classNames(
                  'rotate-0 transition-transform duration-200',
                  {
                    '-rotate-180': isOpen,
                  }
                )}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                >
                  <path
                    d="M1.5332 1.5L4.5332 4.5L7.5332 1.5"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
          ) : (
            children
          )}
        </PopoverButton>
        <PopoverPanel
          anchor={placement}
          static
          className={classNames(
            'z-[1101] rounded-xl border border-black/10 bg-white shadow-custom-md transition-smooth',
            isOpen ? 'scale-100 opacity-100' : 'scale-0 opacity-0',
            panelClassName
          )}
        >
          {content}
        </PopoverPanel>
      </div>
    </Popover>
  );
};

APopover.propTypes = {
  content: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  className: PropTypes.string,
  panelClassName: PropTypes.string,
  showIcon: PropTypes.bool,
};
